export default "__VITE_ASSET__CNRhq4Rf__"